<template>
  <a-drawer
    width="35%"
    :label-col="4"
    :wrapper-col="14"
    :visible="open"
    @cancel="onClose"
    @close="onClose">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :label-col="labelCol" :wrapper-col="wrapperCol" :model="form" :rules="rules">
     <a-form-model-item prop="groupId" >
       <span slot="label" ><a-tooltip>{{ $t('所属小组') }}<template slot="title">{{ $t('所属小组') }}</template></a-tooltip> </span>
        <a-select v-model="form.groupId" :placeholder="$t('请选择')+'所属小组'" allow-clear>
          <a-select-option :value="0">{{ $t('全局话题') }}</a-select-option>
          <a-select-option v-for="item in groupList" :key="item.id" :value="item.id">{{ item.groupName }}</a-select-option>
        </a-select>
     </a-form-model-item>
     <a-form-model-item prop="topicName" >
       <span slot="label" ><a-tooltip>{{ $t('话题名称') }}<template slot="title">{{ $t('话题名称') }}</template></a-tooltip> </span>
       <a-input v-model="form.topicName" :maxLength="64" :placeholder="$t('请输入')+'话题名称'" >
       </a-input>
     </a-form-model-item>
     <a-form-model-item prop="topicCover" >
        <span slot="label" ><a-tooltip>{{ $t('话题封面') }}<template slot="title">{{ $t('话题封面') }}</template></a-tooltip> </span>
       <oss-upload-single :height="200" :width="360" v-model="form.topicCover" prefix="community" type="img"/>
     </a-form-model-item>
     <a-form-model-item prop="topicDesc" >
        <span slot="label" ><a-tooltip>{{ $t('话题描述') }}<template slot="title">{{ $t('话题描述') }}</template></a-tooltip> </span>
        <a-input v-model="form.topicDesc" :maxLength="255" :placeholder="$t('请输入')+'话题描述'" >
       </a-input>
     </a-form-model-item>
     <a-form-model-item prop="viewNum" >
       <span slot="label" ><a-tooltip>{{ $t('浏览数量') }}<template slot="title">{{ $t('浏览数量') }}</template></a-tooltip> </span>
       <a-input-number v-model="form.viewNum" style="width: 100%" :max="9999999" :placeholder="$t('请输入')+'浏览数量'" />
     </a-form-model-item>
     <a-form-model-item prop="isRecommend" >
        <span slot="label" ><a-tooltip>{{ $t('是否推荐') }}<template slot="title">{{ $t('是否推荐') }}</template></a-tooltip> </span>
        <a-select v-model="form.isRecommend" :placeholder="$t('请选择')+'是否推荐'">
          <a-select-option :value="0">{{ $t('不推荐') }}</a-select-option>
          <a-select-option :value="1">{{ $t('推荐') }}</a-select-option>
        </a-select>
     </a-form-model-item>
     <a-form-model-item prop="isEnabled" >
        <span slot="label" ><a-tooltip>{{ $t('是否启用') }}<template slot="title">{{ $t('是否启用') }}</template></a-tooltip> </span>
        <a-select v-model="form.isEnabled" :placeholder="$t('请选择')+'是否启用'">
          <a-select-option :value="0">{{ $t('禁用') }}</a-select-option>
          <a-select-option :value="1">{{ $t('启用') }}</a-select-option>
        </a-select>
     </a-form-model-item>
     <a-form-model-item prop="sort" >
        <span slot="label" ><a-tooltip>{{ $t('排序值') }}<template slot="title">{{ $t('排序值') }}</template></a-tooltip> </span>
        <a-input-number v-model="form.sort" style="width: 100%" :max="9999999" :placeholder="$t('请输入')+'排序值'" />
     </a-form-model-item>
      <a-form-model-item prop="remark" >
        <span slot="label" ><a-tooltip>{{ $t('备注') }}<template slot="title">{{ $t('备注') }}</template></a-tooltip> </span>
        <a-input v-model="form.remark" :placeholder="$t('请输入')" type="textarea" allow-clear />
      </a-form-model-item>
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">
            {{ $t('保存') }}
          </a-button>
          <a-button type="dashed" @click="cancel">
            {{ $t('取消') }}
          </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>
 import { getCommunityGroupTopic, addCommunityGroupTopic, updateCommunityGroupTopic } from '@/api/community/communityGroup/communityGroupTopic'
  import { listCommunityGroup } from '@/api/community/communityGroup/communityGroup'
 import { mapGetters } from 'vuex'
  import CustomDictTag from '@/components/DictCustomTag'
  import { generateFilePath, uploadObject } from '@/api/tool/oss'
  import OssUploadSingle from '@/components/OssUploadSingle/index.vue'
  import LocaleFieldButton from '@/components/locale/LocaleFieldButton.vue'
  import moment from 'moment'

  export default {
    name: 'CreateForm',
  props: {
  },
  components: {
      CustomDictTag,
      LocaleFieldButton,
      OssUploadSingle
  },
  data () {
    return {
      labelCol: { span: 4 },
      wrapperCol: { span: 14 },
      submitLoading: false,
      formTitle: '',
      loading: '',
      // 表单参数
      form: {
        id: null,
        groupId: null,
        topicName: null,
        topicCover: null,
        topicDesc: null,
        viewNum: null,
        isRecommend: null,
        isEnabled: null,
        sort: null,
       remark: null,
       localeFieldMap: {}
     },
      groupList: [],
     // 1增加,2修改
     formType: 1,
     open: false,
     rules: {
          groupId: [{ required: false, message: this.$t('所属小组') + this.$t('不能为空'), trigger: 'blur' }],
         topicName: [{ required: true, message: this.$t('话题名称') + this.$t('不能为空'), trigger: 'blur' }],
         topicCover: [{ required: true, message: this.$t('话题封面') + this.$t('不能为空'), trigger: 'blur' }],
         topicDesc: [{ required: true, message: this.$t('话题描述') + this.$t('不能为空'), trigger: 'blur' }],
         viewNum: [{ required: true, message: this.$t('浏览数量') + this.$t('不能为空'), trigger: 'blur' }],
         isRecommend: [{ required: true, message: this.$t('是否推荐') + this.$t('不能为空'), trigger: 'blur' }],
         isEnabled: [{ required: true, message: this.$t('是否启用') + this.$t('不能为空'), trigger: 'blur' }],
         sort: [{ required: true, message: this.$t('排序值') + this.$t('不能为空'), trigger: 'blur' }]
     }
    }
  },
  filters: {
  },
  created () {
  },
  computed: {
  ...mapGetters(['customDict'])
  },
  watch: {
  },
 mounted () {
    this.loadGroupList()
 },
  methods: {
    moment,
    onClose () {
      this.cancel()
    },
    // 取消按钮
    cancel () {
      this.open = false
      this.reset()
    },
    // 表单重置
    reset () {
      this.formType = 1
      this.form = {
        id: null,
        groupId: null,
        topicName: null,
        topicCover: null,
        topicDesc: null,
        viewNum: null,
        isRecommend: null,
        isEnabled: null,
        sort: null,
        remark: null,
        localeFieldMap: {}
      }
    },
    /** 新增按钮操作 */
   handleAdd (row) {
     this.reset()
     this.formType = 1
     this.open = true
     this.formTitle = this.$t('添加')
      this.loadGroupList()
   },
    /** 修改按钮操作 */
    handleUpdate (row, ids) {
      this.reset()
      this.formType = 2
      const id = row ? row.id : ids
      getCommunityGroupTopic({ 'id': id }).then(response => {
        this.form = response.data
        this.open = true
        this.formTitle = this.$t('修改')
      })
    },
    /** 提交按钮 */
    submitForm: function () {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true
          let message = ''
          if (this.form.id !== undefined && this.form.id !== null) {
           message = this.$t('修改成功')
           updateCommunityGroupTopic(this.form).then(response => {
             if (response.code === '20001') {
               this.$message.success(message, 3)
               this.open = false
               this.$emit('ok')
             }
           }).finally(() => {
             this.submitLoading = false
           })
         } else {
            message = this.$t('新增成功')
           addCommunityGroupTopic(this.form).then(response => {
             if (response.code === '20001') {
               this.$message.success(message, 3)
               this.open = false
               this.$emit('ok')
             }
            }).finally(() => {
              this.submitLoading = false
            })
          }
        } else {
          return false
        }
      })
    },
    /** 加载小组列表 */
    loadGroupList () {
      listCommunityGroup({}).then(response => {
        this.groupList = response.data || []
      })
    }
  }
  }
</script>

